import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Quiz, QuizValue } from '../models';

export const quizActions = createActionGroup({
    source: 'Quiz',
    events: {
        'Get Quiz': props<{ id: string }>(),
        'Get Quiz Success': props<{ payload: Quiz }>(),
        'Get Quiz Error': props<{ code: number; id: string }>(),
        'Create Quiz': props<{ value: QuizValue }>(),
        'Create Quiz Success': props<{ payload: Quiz }>(),
        'Create Quiz Error': props<{ code: number }>(),
        'Update Quiz': props<{ id: string; value: QuizValue }>(),
        'Update Quiz Success': props<{ payload: Quiz }>(),
        'Update Quiz Error': props<{ code: number }>(),
        'Delete Quiz': props<{ id: string }>(),
        'Delete Quiz Success': props<{ id: string }>(),
        'Delete Quiz Error': props<{ code: number }>(),
        Clear: emptyProps(),
    },
});
